import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";
import { ConfiguracioService } from "./configuracio.service";
import { IApiCentresServeiMunicipis } from "./api.model";

export class CentresPreinscripcioService {
  private apiUrl = `${this.SharedProperties.baseUrlService()}/MOE/services/centres/preinscripcio`;

  constructor(
    private NotificationsService: NotificationsService,
    private Configuracio: ConfiguracioService,
    private SharedProperties: SharedProperties,
    private $http: angular.IHttpService,
    private $rootScope: angular.IRootScopeService
  ) { }

  getCentresPreinscripcio(paramsMapes: any): angular.IPromise<any> {
    const _params = { ...paramsMapes };
    return this.$http
      .post(`${this.apiUrl}/find?`, _params)
      .then((response: any) => ({
        centres: response.data.centres,
        registresTotal: response.data.registresTotal
      }))
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error al carregar els centres", "error");
        this.$rootScope.$broadcast("error");
      });
  }

  getFilter(codi: string): angular.IPromise<any> {
    return this.$http
      .get(`${this.apiUrl}/MOE/services/cridesExternes/get/${codi}`)
      .then((response) => ({ filtre: response.data }))
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit al recuperar el filtre del link", "error");
        this.$rootScope.$broadcast("error");
      });
  }

  getCentrePreinscripcio(paramsMapes: any): angular.IPromise<any> {
    const _params = { ...paramsMapes };
    return this.$http
      .post(`${this.apiUrl}/findCentre?`, _params)
      .then((response: any) => ({
        centres: response.data.centres,
        registresTotal: response.data.registresTotal
      }))
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error al carregar els centres", "error");
        this.$rootScope.$broadcast("error");
      });
  }

  getNomCentresPreinscripcioAhead(paramsMapes: any): angular.IPromise<any[]> {
    const _params = { ...paramsMapes };
    return this.$http
      .post(`${this.apiUrl}/findTypeahead?`, _params)
      .then((response: any) => response.data.centres.map((item: any) => item));
  }

  getCentresPreinscripcioAdscrits(codiCentre: string): angular.IPromise<any> {
    const config = { params: { codiCentre } };
    return this.$http
      .get(`${this.apiUrl}/findAdscrits`, config)
      .then((response: any) => response.data.centres)
      .catch(() => this.NotificationsService.sendMessage("S'ha produit un error", "error"));
  }

  getCentresPreinscripcioAdscritsPare(codiCentre: string): angular.IPromise<any> {
    const config = { params: { codiCentre } };
    return this.$http
      .get(`${this.apiUrl}/findAdscritsPare`, config)
      .then((response: any) => response.data.centres)
      .catch(() => this.NotificationsService.sendMessage("S'ha produit un error", "error"));
  }

  getGeoserverCentres(centre: any): angular.IPromise<any> {
    const filter = `(1=1) AND (CODI_CENTRE= '${centre.codiCentre}')`;
    const config = this.Configuracio.getConfiguracio();
    const urlTemplate = `${config.geoServerUrlPreinscripcio}service=wfs&version=1.1.0&request=GetFeature&typeName=${config.geoServerPreinscripcioLayers}&CQL_FILTER=${filter}&outputFormat=application/json&srsname=EPSG:3857`;

    return this.$http.get(urlTemplate).then((response: any) => ({
      id: centre.codiCentre,
      centre,
      dataGeoserver: {
        ...response.data,
        features: response.data.features.map((feature: any) => ({
          ...feature,
          properties: {
            ...feature.properties,
            LAT: centre.coordX,
            LNG: centre.coordY,
            esCentreNou: centre.esCentreNou
          }
        }))
      }
    }));
  }

  getGeoserverCentresServeis(centre: IApiCentresServeiMunicipis): angular.IPromise<any> {
    const filter = `(1=1) AND (COD_CENTRES_DOCENTS= '${centre.codi}')`;
    const config = this.Configuracio.getConfiguracio();
    const urlTemplate = `${config.geoServerUrlPreinscripcio}service=wfs&version=1.1.0&request=GetFeature&typeName=${config.geoServerServeisEducatiusLayersTwo}&CQL_FILTER=${filter}&outputFormat=application/json&srsname=EPSG:3857`;

    return this.$http.get(urlTemplate).then((response: any) => ({
      id: centre.codi,
      centre,
      dataGeoserver: {
        ...response.data,
        features: response.data.features.map((feature: any) => ({
          ...feature,
          properties: {
            ...feature.properties,
            LAT: centre.coordX,
            LNG: centre.coordY,
          }
        }))
      }
    }));
  }

  getCentresPreinscripcioCoordinates(paramsMapes: any): angular.IPromise<any> {
    const _params = { ...paramsMapes };
    return this.$http
      .post(`${this.apiUrl}/findCoordinatesCentres?`, _params)
      .then((response: any) => ({
        centres: response.data.centres,
        registresTotal: response.data.registresTotal
      }))
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error al carregar els centres", "error");
        this.$rootScope.$broadcast("error");
      });
  }
}

angularJsApp.service(AppServicesEnum.CENTRES_PREINSCRIPCIO_SERVICE, CentresPreinscripcioService);